import { service } from '@ember/service';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export default class SubscriptionUserAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  // @ts-expect-error: Property 'buildURL' in type 'SubscriptionUserAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  buildURL(
    modelName: string,
    id: string,
    snapshot: unknown,
    requestType: string,
  ): string {
    if (requestType === 'deleteRecord') {
      const subscriptionId = this.hotelAndMarketService.hotel.id;
      return `${this.host}/${APIGATEWAY}/subscriptions/${subscriptionId}/users/${id}/`;
    }

    // @ts-expect-error: Expected 3 arguments, but got 4.
    return super.buildURL(modelName, id, snapshot, requestType);
  }
}
